import { Formik, Form } from 'formik'
import { useEffect, useState } from 'react'
import Column from '@components/column'
import Button from '@components/button'
import Svg from '@components/svg'
import CardHeading from '@commons/headings/card'
import { StyleHalfWrapper, StyleRowWrapper, StyleSampleWrapper } from './style'
import Fields from '@components/fields'
import { useSelector } from 'react-redux'
import { Category } from '@apis'
import Typography from '@components/typography'
import Row from '@components/row'
import { MedicineSchema } from '@validations'
import { Medicine } from '@apis'
import { useLocation, useNavigate, useParams } from 'react-router-dom'
const MedicineForm = () => {
  const [initialValues, setInitialValues] = useState({
    categoryId: '',
    subCategoryId: '',
    file: '',
  })
  const { state } = useLocation()
  const navigate = useNavigate()
  const [loading, setLoading] = useState<boolean>(false)
  const { data: subCategories } = useSelector(
    (state: any) => state.medicineSubCategories,
  )
  const { data: categories } = useSelector(
    (state: any) => state.medicineCategories,
  )

  const fetchCategories = async () => {
    await Category.list({
      params: {
        type: 'Medicine',
      },
      state: 'medicineCategories',
    }).catch(() => {})
  }

  const fetchSubCategories = async (parentId) => {
    await Category.list({
      params: {
        type: 'MedicineSubCategory',
        parentId,
      },
      state: 'medicineSubCategories',
    }).catch(() => {})
  }

  const handleDownload = () => {
    const a = document.createElement('a')
    a.href = `${window.location.origin}/Sample.csv`
    a.download = 'Sample.csv'
    a.click()
  }

  const submitHandler = async (values) => {
    setLoading(true)
    const subCategory = subCategories?.find(
      (category: any) => category?.id == values?.subCategoryId,
    )
    const payload: any = {
      categoryId: values?.categoryId,
      subCategoryId: values?.subCategoryId,
      fileName: subCategory?.name?.toLowerCase(),
      file: values?.file?.base64
        ? {
            base64: values?.file?.base64,
            extension: values?.file?.extension,
          }
        : values?.file,
    }
    if (!!state?.id) {
      await Medicine.update({
        data: payload,
        id: state?.id,
      })
        .then(() => {
          setInitialValues({
            categoryId: '',
            subCategoryId: '',
            file: '',
          })
          navigate('.')
        })
        .catch(() => {})
    } else {
      payload.status = true
      await Medicine.create({
        data: payload,
      }).catch(() => {})
    }

    setLoading(false)
  }

  useEffect(() => {
    if (!categories?.length) {
      fetchCategories()
    }
  }, [])

  useEffect(() => {
    if (state?.id) {
      fetchSubCategories(state?.category?.id)
      setInitialValues({
        categoryId: state?.category?.id,
        subCategoryId: state?.subCategory?.id,
        file: state?.file,
      })
    }
  }, [state?.id])

  return (
    <Column
      bg="white"
      styleColumn="padding:15px;border-radius:12px;"
      rowGap={20}
    >
      <CardHeading title="Add Medicine" />
      <StyleSampleWrapper>
        <Row colGap={5}>
          <Svg svg="info" />
          <Typography
            content="Download Sample CSV and fill all the medicine name Upload the CSV."
            size={14}
          />
        </Row>
        <Button
          title="Download Sample Type"
          leftComponent={<Svg svg="download" color={'secondary'} />}
          outline
          bg="secondary"
          onClick={handleDownload}
        />
      </StyleSampleWrapper>
      <Formik
        initialValues={initialValues}
        onSubmit={submitHandler}
        enableReinitialize
        validationSchema={MedicineSchema.validationSchema}
      >
        {({ handleSubmit, setFieldValue, errors }) => {
          return (
            <Form onSubmit={handleSubmit}>
              <Column rowGap={20}>
                <StyleRowWrapper>
                  <StyleHalfWrapper>
                    <Fields.DropDown
                      label="Category"
                      name="categoryId"
                      options={categories}
                      titleAsKey="name"
                      valueAsKey="id"
                      placeholder="Select Category"
                      hasSearch
                      onChange={(value) => {
                        setFieldValue('categoryId', value)
                        fetchSubCategories(value)
                      }}
                    />
                  </StyleHalfWrapper>
                  <StyleHalfWrapper>
                    <Fields.DropDown
                      label="Sub Category"
                      name="subCategoryId"
                      options={subCategories}
                      titleAsKey="name"
                      valueAsKey="id"
                      placeholder="Select Sub Category"
                      hasSearch
                    />
                  </StyleHalfWrapper>
                </StyleRowWrapper>
                <StyleHalfWrapper>
                  <Fields.Upload
                    name="file"
                    label="Upoad File"
                    varient="input"
                    placeholder="Upload File"
                    accept=".csv, .xls, .xlsx"
                  />
                </StyleHalfWrapper>
                <Column alignItems="flex-end">
                  <Button
                    title="Submit"
                    height={50}
                    type="submit"
                    loading={loading}
                  />
                </Column>
              </Column>
            </Form>
          )
        }}
      </Formik>
    </Column>
  )
}

export default MedicineForm
